import Carousel from "react-material-ui-carousel";
import { Box, Stack } from "@mui/system";
import { Badge, Typography } from "@mui/material";
import { useSelector } from "react-redux";
const ProductsSliderCarousel = () => {
  const allProducts = useSelector((state) => state.giftsProducts.allProducts);

  return (
    <Box width="100%">
      <Carousel
        navButtonsAlwaysVisible={true}
        animation="slide"
        duration="1000"
        height="320px"
      >
        {allProducts?.map((item, i) => (
          <Stack
            direction="column"
            padding="12px"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Badge
              badgeContent={
                item.points === 1
                  ? item.points + " poen"
                  : item.points + " poena"
              }
              color="error"
            >
              <img src={item.picture.url} alt="product" width="100px" />
            </Badge>
            <Typography variant="h6">{item.name}</Typography>
          </Stack>
        ))}
      </Carousel>
    </Box>
  );
};

export default ProductsSliderCarousel;
